import { createBrowserRouter } from 'react-router';

import PlaceholderPage from './pages/PlaceholderPage';
import RouteErrorPage from './pages/RouteErrorPage';

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <RouteErrorPage />,
    children: [{ index: true, element: <PlaceholderPage /> }],
  },
]);
